import React, { useEffect, useState } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import Table from "react-bootstrap/Table";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { generateBarCode, getOrderHistory, getShipmentDetailsById } from "../../store/actions/history";
import moment from 'moment';
import LoaderSpinner from "../common/Loader";
import DraftEmail from "../common/DraftEmail";
import ExportOrderCsv from "../common/ExportOrderCsv";
import BatchPagination from "../batch/BatchPagination";
import _ from "lodash";
import { cancelShipmentService, createPackingSlip, createScanForm, getMergedPdf } from "../../store/actions/batch.action";
import HistoryFilter from "./HistoryFilter";
import { Tooltip as WmsTooltip } from "react-tooltip";
import { toast } from "react-toastify";
import { dateFilters, featureSubmodulePermission, fulfilledBy, historyModule, numOfPage, orderManagement, permssionCreate } from "../../constant";
import { checkPermission, findIsHostShipAi } from "../../config/utils";
import DetailedReports from "./DetailedStatementReport";
import AlertDialogModal from "../common/AlertDialog";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { getActivePrintListAction, handleAutoPrintAction } from "../../store/actions/barcode.action";
import { useTextToSpeech } from '../../config/utils';
import TrackingDetails from "./TrackingDetails";
import UniUniTrackingDetails from "./UniUniTrackingDetails";
import GoFoTrackingDetails from "./GoFoTrackingDetails";
import { useNavigate } from "react-router-dom";

/*istanbul ignore next */
function TrackHistory() {
  const { handleSpeak } = useTextToSpeech();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.auth.user);
  const { historyRecords, historyRecordStatus } = useSelector(
    (state) => state.HistoryReducer
  );
  const [modalShow, setModalShow] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [historyData, setHistoryData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [enableScanForm, setEnableScanForm] = useState(true);
  const [sellerList, setSellerList] = useState([]);
  const [allSellers, setAllSellers] = useState([]);
  const [idList, setIdList] = useState([]);
  const [trackingNumber, setTrackingNumber] = useState({});
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [showUniUniTrackingModal, setShowUniUniTrackingModal] = useState(false);
  const [showGoFoTrackingModal, setShowGoFoTrackingModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState({ show: false, record: null });

  let historyFormData = {
    pageIndex: 1,
    pageSize: 30,
    companyId: userDetails?.Value?.companyId,
    orderNumber: "",
    isAdmin: userDetails?.Value?.isSuperAdmin,
    createdBy: userDetails?.Value?.employeeId,
    sellerId: userDetails?.Value?.sellerId,
    orderStatusId: 0,
    companySellerId: userDetails?.Value?.companySellerId,
    labelCreationFrom: moment(new Date()).utc(true).format(),
    labelCreationTo: null,
    weightUnit: 0,
    referenceSearchText: '',
    receiverSearchText: '',
    shipTo: null,
    shipFrom: null,
    quoteMin: '',
    weightMin: '',
    weightMax: '',
    quoteMax: '',
    carrierIdList: [],
    numPiece: '',
    serviceIdList: [],
    shipmentStatus: 0,
    companyIdList: [],
    sellerIdList: [],
    showFilter: false,
    numberOfPage: 30,
    quickFilter: '0',
    fulfilledBy: 1
  }
  const { filterBackDetails } = useSelector((state) => state.batchReducer);
  const [defaultFilterData, setDefaultFilterData] = useState({});
  const [currentItemSelected, setCurrentItemSelected] = useState({});
  const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);

  useEffect(() => {
    if (!_.isEmpty(filterBackDetails)) {
      setDefaultFilterData({ ...defaultFilterData, ...filterBackDetails });
    } else {
      setDefaultFilterData({ ...historyFormData });
    }
    setTrackingNumber({ ...historyFormData, labelCreationFrom: null })
  }, []);

  const handleReset = () => {
    let data = JSON.parse(JSON.stringify(historyFormData));
    data.pageSize = defaultFilterData.pageSize;
    setDefaultFilterData(data);
    dispatch(getOrderHistory(data));
    setIdList([]);
    setSellerList(allSellers)
  }

  useEffect(() => {
    if (historyRecordStatus !== "success") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [historyRecordStatus]);
  useEffect(() => {
    let findCheckedRecords = historyData.filter((item) => item.isChecked).length;
    if (findCheckedRecords > 0) {
      // eslint-disable-next-line array-callback-return
      let findDate = historyData.filter((item) => {
        let dateCreated = moment(item.CreatedDate).format("DD-MM-YYYY");
        let dateNow = moment(new Date()).format("DD-MM-YYYY");
        if (item?.SupportsScanForm && item?.isChecked && dateCreated === dateNow) {
          return item;
        }
      });
      setEnableScanForm(findDate.length === findCheckedRecords ? false : true);
    } else {
      setEnableScanForm(true);
    }
  }, [historyData]);

  useEffect(() => {
    if (historyRecords?.Entity?.historyTrackEntities?.length) {
      setHistoryData(_.cloneDeep(historyRecords.Entity.historyTrackEntities));
      setTotalPages(
          Math.ceil(
              (historyRecords.Entity.TotalRecords || 0) / (defaultFilterData?.pageSize || 30)
          )
      );
      setTrackingNumber({ ...trackingNumber, referenceSearchText: '' });
    } else {
        setHistoryData([]);
        setTotalPages(0);
    }
  }, [historyRecords]);

  useEffect(() => {
    if (!_.isEmpty(defaultFilterData)) {
      fetchHistory();
    }
  }, [defaultFilterData?.pageSize, defaultFilterData.pageIndex]);

  const fetchHistory = () => {
    let historyObj = {
      ...defaultFilterData,
      carrierIdList: _.map(defaultFilterData.carrierIdList, "id") || [],
      serviceIdList: _.map(defaultFilterData.serviceIdList, "id") || [],
      companyIdList: _.map(defaultFilterData.companyIdList, "Id") || [],
      sellerIdList: _.map(defaultFilterData.sellerIdList, "id") || []
    };
    dispatch(getOrderHistory(historyObj));
  };

  const handlePrintLabel = (item) => {
    window.open(item.ShippingLabel, "PRINT", "height=400,width=600");
  };

  const handleEmailLabel = (item) => {
    setModalShow(true);
    setSelectedRecord(item);
  };

  const handleDownloadLabel = async () => {
    setLoader(true);
    let checkedData = historyData.filter((item) => {
      if (item?.isChecked && item.IsPrintLabelEnable) {
        return item;
      }
    });
    let checkedDataLength = historyData.filter(item => item?.isChecked).length;
    if (checkedData.length) {
      let data = _.map(checkedData, "OrderNumber");
      let mergedRes = await getMergedPdf(data);
      if (mergedRes?.data?.Status === 200) {
        if (checkedDataLength !== checkedData.length) {
          toast.info('Some of the orders may have already delivered');
        } else {
          toast.success('Orders reprinted successfully');
        }
        let updateIsChecked = historyData.map((record) => {
          return {
            ...record,
            isChecked: false,
          };
        });
        setIdList([]);
        setHistoryData(updateIsChecked);
        window.open(mergedRes.data.Entity);
      }
    } else {
      toast.error('Can not reprint selected order(s) label');
    }
    setLoader(false);
  };

  const handleCheckRecord = (e, type) => {
    const { checked } = e.target;
    let recordData = [...historyData];
    let newIdList = [...idList];
    if (type === "all") {
      if (checked) {
        let markCheck = recordData.map((item) => ({
          ...item,
          isChecked: item.IsPrintDisabled ? false : true,
        }));
        setHistoryData(markCheck);
        let data = _.map(markCheck, "ShipmentId");
        setIdList(data);
      } else {
        let markCheck = recordData.map((item) => ({
          ...item,
          isChecked: false,
        }));
        setIdList([]);
        setHistoryData(markCheck);
      }
    } else {
      recordData[type].isChecked = checked;
      if (checked) {
        newIdList.push(recordData[type].ShipmentId);
      } else {
        newIdList = newIdList.filter(id => id !== recordData[type].ShipmentId);
      }
      setHistoryData(recordData);
      setIdList(newIdList);
    }
  };

  const handleCreateScanForm = async () => {
    let scanFormData = `companySellerId=${userDetails?.Value.companySellerId}&createdBy=${userDetails?.Value.employeeId}`;
    let findCheckedRecords = historyData.filter((item) => item.isChecked);
    let data = _.map(findCheckedRecords, "ShipmentId");

    let resScanForm = await createScanForm(scanFormData, data);
    if (resScanForm?.data?.Status === 200) {
      toast.success('Scan form created Successfully');
      window.open(resScanForm.data.Entity, "_blank");
    } else if (resScanForm.data.Status === 400) {
      if (!resScanForm.data.Entity) {
        toast.error(resScanForm.data?.Message?.AppStatusDescription);
      } else {
        toast.error('Some error while creating scan form');
        window.open(resScanForm.data.Entity, "_blank");
      }
    } else {
      toast.error(resScanForm.data?.Message?.AppStatusDescription);
    }
    let updateIsChecked = historyData.map((record) => {
      return {
        ...record,
        isChecked: false,
      };
    });
    setHistoryData(updateIsChecked);
  };

  const handlePackingSlip = async (e, item) => {
    e.preventDefault();
    let data = {
      orderId: item.OrderId ? item.OrderId : item.OrderNumber,
      ...(item.OrderId && { shipmentType: 'CSV' })
    }
    let response = await Promise.resolve(dispatch(createPackingSlip(data)));
    if (response.data.Status === 200 && response.data.Entity) {
      window.open(response.data.Entity, "PRINT", "height=400,width=600");
      toast.success('Packing slip generated successfully')
    } else {
      toast.error(response.data.Message.AppStatusDescription);
    }
  }

  const handleQuickDateFilter = (e) => {
    const { value } = e.target;
    const data = JSON.parse(JSON.stringify(defaultFilterData));
    const days = Number(value);
    if (days === 0) {
      data.labelCreationFrom = moment().utc(true).startOf('day').toISOString();
      data.labelCreationTo = moment().utc(true).endOf('day').toISOString();
    } else if (days === 1) {
      data.labelCreationFrom = moment().subtract(1, 'days').utc(true).startOf('day').toISOString();
      data.labelCreationTo = moment().subtract(1, 'days').utc(true).endOf('day').toISOString();
    } else {
      data.labelCreationFrom = moment().subtract(days, 'days').utc(true).startOf('day').toISOString();
      data.labelCreationTo = moment().utc(true).endOf('day').toISOString();
    }
    data.pageIndex = 1;
    data.quickFilter = value;
    setDefaultFilterData(data);
    dispatch(getOrderHistory(data));
  };
  const handleRequestRefund = (e, item) => {
    e.preventDefault();
    setShowAlertModal({ show: true, record: item });
  };

  const handleSelectedRequestRefund = (e) => {
    e.preventDefault();
    const selectedRecords = historyData.filter(
      (item) => item?.isChecked
        && item.IsPrintLabelEnable
        && item?.BookingStatus !== 'Cancellation In-Progress'
        && item?.BookingStatus !== 'Refunded'
    );

    if (!selectedRecords.length) {
      toast.error('Please select refundable record(s)');
      return;
    }

    setShowAlertModal({ show: true, record: selectedRecords });
  };

  const getProviderShipmentIds = (providerShipmentId) => {
    if (Array.isArray(providerShipmentId)) {
      return providerShipmentId.map(Number).filter((id) => !Number.isNaN(id));
    }

    if (!providerShipmentId) {
      return [0];
    }

    return String(providerShipmentId)
      .split(',')
      .map((id) => Number(id.trim()))
      .filter((id) => !Number.isNaN(id));
  };

  const handleDeleteConfirm = async () => {
    setShowAlertModal({ show: false, record: null });
    const selectedRecords = Array.isArray(showAlertModal.record) ? showAlertModal.record : [showAlertModal.record];

    for (const record of selectedRecords) {
      let data = {
        trackingNumber: record.TrackingNumber,
        orderNumber: record.OrderNumber,
        providerShipmentId: getProviderShipmentIds(record.ProviderShipmentId || record.providerShipmentId)
      };

      const response = await Promise.resolve(dispatch(cancelShipmentService(data)));
      if (response.data.Status !== 200) {
        toast.error(response.data.Message.AppStatusDescription);
        return;
      }
    }

    toast.success('Refund request raised successfully');
    fetchHistory();
  }

  const updateUserInputNum = (e) => {
    const { value } = e.target;
    const dataClone = JSON.parse(JSON.stringify(defaultFilterData));
    const data = JSON.parse(JSON.stringify(defaultFilterData));
    dataClone.pageIndex = value;
    data.pageIndex = 1;
    data.carrierIdList = _.map(defaultFilterData.carrierIdList, "id") || [];
    data.serviceIdList = _.map(defaultFilterData.serviceIdList, "id") || [];
    data.companyIdList = _.map(defaultFilterData.companyIdList, "Id") || [];
    data.sellerIdList = _.map(defaultFilterData.sellerIdList, "id") || [];
    data.fulfilledBy = value;
    dataClone.fulfilledBy = value;

    setDefaultFilterData(dataClone);
    dispatch(getOrderHistory(data));
  };

  const getStatusClassName = (bookingStatus) => {
    if (bookingStatus?.includes('Cancellation')) {
      return 'activeStatus activeStatusInprogress';
    } else if (bookingStatus?.includes('Refunded')) {
      return 'activeStatus activeStatusRefunded';
    } else if (bookingStatus?.includes('Pending')) {
      return 'activeStatus activeStatusInprogress'; 
    } else if (bookingStatus?.includes('Delivered')) {
      return 'activeStatus activeStatusClosed';
    } else if (bookingStatus?.includes('In-Transit')) {
      return 'activeStatus Intransit';
    }
    return 'activeStatus';
  };

  const filterByTrackingNumber = (e, action) => {
    const isEnterKey = action === 'ENTER' && e.key === 'Enter';
    const isSearchAction = action === 'SEARCH';

    if ((isEnterKey && trackingNumber.referenceSearchText) || isSearchAction) {
      dispatch(getOrderHistory(trackingNumber));
    }
  };

  const handlePrintByOrderNumber = async (response) => {
    const res = await getActivePrintListAction();
    let printerList = res?.data?.data;
    if (printerList?.length) {
      let findActive = printerList.filter((printer) => printer.isDefault);
      if (findActive.length) {
        let data = {
          PrinterName: findActive[0].printerName,
          FileBase64: response.PdfDataString
        };
        handleAutoPrintAction(data).then((res) => {
          handleSpeak("Print successfully");
        }, err => { toast.error("Looks like you are not connected to printer. Please contact the administrator.") });
      } else {
        toast.error("Looks like you are not connected to printer. Please contact the administrator.");
      }
    } else {
      toast.error("No Printer Found. Please contact the administrator.")
    }
  }

  const handleDownloadLabelPDF = (response) => {
    const linkSource = response.PdfFileUrl;
    window.open(linkSource, "_blank");
    toast.success("Download successfully");
  }

  const handleAutoPrint = async (response) => {
    try {
      if (response.FileActionValue === 2) {
        handlePrintByOrderNumber(response);
      } else if (response.FileActionValue === 1) {
        handleDownloadLabelPDF(response);
      } else if (response.FileActionValue === 3) {
        handlePrintByOrderNumber(response);
        handleDownloadLabelPDF(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGenerateBarcode = async (e, item) => {
    e.preventDefault();
    let data = {}
    if (Array.isArray(item)) {
      let checkedDataLength = historyData.filter(item => item?.isChecked).length;
      if (checkedDataLength) {
        let checkedData = historyData.filter((item) => {
          if (item?.isChecked && item.IsPrintLabelEnable) {
            return item;
          }
        });
        data = {
          orderNumbers: _.map(checkedData, "OrderNumber"),
        }
      }
    } else {
      data = {
        orderNumbers: [item.OrderNumber],
      }
    }
    let response = await generateBarCode(data);
    if (response.data.Status === 200 && response.data.Entity) {
      handleAutoPrint(response.data.Entity);
    } else {
      toast.error(response.data.Message.AppStatusDescription);
    }
  };

  const handleGetTracking = (item) => {
    setCurrentItemSelected(item);
    setShowTrackingModal(true);
  };

  const handleGetUniUniTracking = (item) => {
    setCurrentItemSelected(item);
    setShowUniUniTrackingModal(true);
  };

  const handleGetGoFoTracking = (item) => {
    setCurrentItemSelected(item);
    setShowGoFoTrackingModal(true);
  };

  const renderTrackingNumber = (item) => {
    if (item.HasTrackingPopup) {
      return (
        <button
          className="trackingNumber sortBtn tableLink alignLeft"
          onClick={() => handleGetTracking(item)}
          style={{ cursor: 'pointer', color: '#0d6efd' }}
        >
          {item.TrackingNumber}
        </button>
      );
    }
    if (item.ServiceType?.toLowerCase().includes('uni uni')) {
      return (
        <button
          className="trackingNumber sortBtn tableLink alignLeft"
          onClick={() => handleGetUniUniTracking(item)}
          style={{ cursor: 'pointer', color: '#0d6efd' }}
        >
          {item.TrackingNumber}
        </button>
      );
    }
    if (item.ServiceType?.toLowerCase().includes('gofo')) {
      return (
        <button
          className="trackingNumber sortBtn tableLink alignLeft"
          onClick={() => handleGetGoFoTracking(item)}
          style={{ cursor: 'pointer', color: '#0d6efd' }}
        >
          {item.TrackingNumber}
        </button>
      );
    }
    return (
      <a href={item.TrackingUrl} target="_blank" rel="noreferrer">
        {item.TrackingNumber}
        <i className="fa fa-external-link marginLeft5" aria-hidden="true"></i>
      </a>
    );
  };

  const handleEditReship = async(e, item) => {
    e.preventDefault();
    setLoader(true);
    let response = await getShipmentDetailsById(item.ShipmentId);
    setLoader(false);
    if (response.data.Status === 200 && response.data.Entity) {
      let data = {
        ...response.data.Entity,
        orderID: 0,
        packageID: response.data.Entity.packageId,
        ordernumber: '',
      }
      navigate('/shipment', { state: { shipmentDetails: data, isEditReship: true } });
    } else {
      toast.error(response.data.Message.AppStatusDescription);
    }
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec historyHeading mb-0">
          <span className="historyHeadingTitle">Label (History/Track)</span>
          <div className="top_right_button_container historyButton">
            <>
              <span className="shippingHistoryPeriod item">
                <div className="mr-2">Period</div>
                <select
                  className="form-control cus-select-filter"
                  onChange={(e) => handleQuickDateFilter(e)}
                  value={defaultFilterData.quickFilter}
                  disabled={loader}
                >
                  {dateFilters.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </span>
              <div className="mr-2 fulfillWrapper">
                <FormControl variant="outlined">
                  <InputLabel id="demo-simple-select-outlined-label">Fulfillment</InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={defaultFilterData.fulfilledBy || 1}
                    disabled={loader}
                    label="Fulfillment"
                    name={'fulfilledBy'}
                    onChange={(e) => updateUserInputNum(e)}
                  >
                    {fulfilledBy.map((item, index) => (
                      <MenuItem className='optionService' id={item.id} key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {checkPermission(orderManagement, historyModule, permssionCreate, featureSubmodulePermission, employeePermissions) && (
                <button
                  className="btn cus-seconday-bg-btn top-btn createScanFormBtn"
                  onClick={handleCreateScanForm}
                  id='scanformBtn'
                  disabled={enableScanForm}
                >
                  Scan Forms {" "}
                  <i id="scanformBtnIcon" className="fa fa-info marginLeft5" aria-hidden="true" ></i>
                  {enableScanForm && (
                    <WmsTooltip
                      anchorId={'scanformBtnIcon'}
                      place="top"
                      className="tooltipWidth"
                    >Select current date records only.</WmsTooltip>
                  )}
                </button>
              )}
            </>
            <button
              className="btn cus-seconday-bg-btn top-btn downloadLabelBtn rePrint"
              onClick={handleDownloadLabel}
              disabled={!historyData?.filter((item) => item.isChecked).length || loader}
            >
              Reprint
            </button>
            <Button
              className="cus-seconday-bg-btn showHideFilter top-btn"
              disabled={!historyData?.filter((item) => item.isChecked).length || loader}
              onClick={handleSelectedRequestRefund}
            >Request Refund</Button>

            <Dropdown className="dropBtnInline" drop="down">
              <Dropdown.Toggle
                className="btn cus-seconday-bg-btn top-btn"
                id="dropdown-basic"
              >
                Statement
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item className="picked">
                  <ExportOrderCsv
                    idList={idList}
                    gridData={historyData}
                    csvData={defaultFilterData}
                  />
                </Dropdown.Item>
                <Dropdown.Item className="Intransit">
                  <DetailedReports dispatch={dispatch} />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button
              className="cus-seconday-bg-btn showHideFilter top-btn"
              disabled={!historyData?.filter((item) => item.isChecked).length || loader}
              onClick={(e) => handleGenerateBarcode(e, [])}
            >Generate Barcode</Button>
            <Button
              className="cus-seconday-bg-btn showHideFilter"
              onClick={() => setDefaultFilterData({ ...defaultFilterData, showFilter: !defaultFilterData.showFilter })}
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </Button>



          </div>
        </div>

        <HistoryFilter
          showFilter={defaultFilterData.showFilter}
          userDetails={userDetails}
          defaultFilterData={defaultFilterData}
          setDefaultFilterData={setDefaultFilterData}
          handleReset={handleReset}
          setIdList={setIdList}
          setTotalPages={setTotalPages}
          historyFormData={defaultFilterData}
          HistoryFormData={JSON.parse(JSON.stringify(historyFormData))}
          sellerList={sellerList}
          setSellerList={setSellerList}
          allSellers={allSellers}
          setAllSellers={setAllSellers}
        />
        <div className="mt-3 displayFlex">
          <input className="form-control searchInput mr-2"
            type="text"
            placeholder="Search by Tracking Number or Order Number"
            value={trackingNumber.referenceSearchText || ''}
            onChange={(e) => {
              setTrackingNumber({ ...trackingNumber, referenceSearchText: e.target.value });
            }}
            disabled={loader}
            onBlur={(e) => setTrackingNumber({ ...trackingNumber, referenceSearchText: e.target.value.trim() })}
            onKeyDown={(e) => filterByTrackingNumber(e, 'ENTER')}
          />
          <button className="cus-seconday-bg-btn btn" disabled={!trackingNumber.referenceSearchText} onClick={(e) => filterByTrackingNumber(e, 'SEARCH')}>Search</button>
        </div>
        <div className="main_content cus-page-content-sec">
          {historyRecordStatus !== "success" && <LoaderSpinner />}
          <div className="main_content_table_history">
            <div className="tableFixHead incomingTbl">
              <Table className="table-height cus-left-right-col-layout">
                <thead border="Green">
                  <tr>
                    <th>
                      <input
                        className="checkAll"
                        checked={
                          historyData.filter((item) => item.isChecked && !item.IsPrintDisabled).length > 0 &&
                          historyData.filter((item) => !item.IsPrintDisabled).length ===
                          historyData.filter((item) => item.isChecked && !item.IsPrintDisabled).length
                        }
                        type={"checkbox"}
                        onChange={(e) => handleCheckRecord(e, "all")}
                      />
                    </th>
                    <th>Tracking Number</th>
                    {userDetails?.Value?.roleName !== 'Seller' && (
                      <th width={"15%"}>Company / Seller Name</th>
                    )}
                    <th>Service Type / Package Type</th>
                    <th>Pieces / Weight / Quoted</th>
                    <th>Ship Date / Label Creation Date</th>
                    <th>Order Number / Shipper Reference</th>
                    <th>Receiver / Return To</th>
                    <th>Status</th>
                    <th className="">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {historyRecords && historyData.length > 0 && (
                    <>
                      {historyData.map((item, index) => (
                        <tr key={item.OrderId}>
                          <td>
                            <input
                              className="historyCheck"
                              type={"checkbox"}
                              checked={!item.IsPrintDisabled && (Boolean(item.isChecked) || idList.includes(item.ShipmentId))}
                              onChange={(e) => handleCheckRecord(e, index)}
                              disabled={item.IsPrintDisabled}
                            />
                          </td>
                          <td>
                            {!item.IsLabelGeneratedExternally && item.TrackingNumber && (
                              <>
                                {renderTrackingNumber(item)}
                              </>
                            )}

                            {item.IsLabelGeneratedExternally && (
                              <span>{item.TrackingNumber}</span>
                            )}
                          </td>
                          {userDetails?.Value?.roleName !== 'Seller' && (
                            <td width={"10%"}>{item.CompanySellerName}</td>
                          )}
                          <td>
                            <div>{item.ServiceType}</div>
                            {item.PackageType}
                          </td>
                          <td>
                            {item.TotalQuantity}
                            <br />
                            {item.TotalWeight} (
                            {item.TotalWeight &&
                              (item.WeightUnit ? item.WeightUnit : "LBS")}
                            )<br />$
                            {(Math.round(item.Rate * 100) / 100).toFixed(2)}
                          </td>
                          <td width={"10%"}>
                            {moment(item.ShipmentDate).format("MM-DD-YYYY")}
                            <br />
                            {moment(item.CreatedDate).format(
                              "MM-DD-YYYY | h:mm:ss A"
                            )}
                          </td>
                          <td>
                            <div className="wordWrap">{item.OrderNumber}</div>
                            <div className="wordWrap">{item?.Note}</div>
                          </td>
                          <td>
                            <div>{item?.ReceiverName}</div>
                            {item.ReceiverAddressLine1} {item.ReceiverAddressLine2} {item.ReceiverCity}{" "}
                            {item.ReceiverState} {item.ReceiverZip}{" "}
                            {item.CountryCode}
                          </td>
                          <td>
                            <span className={getStatusClassName(item.BookingStatus)}>
                              {item.BookingStatus ? item.BookingStatus : "Booked"}
                            </span>
                          </td>
                          <td>
                            <Dropdown className="historyPopper">
                              <Dropdown.Toggle className="opneDropDownMenu">
                                <i
                                  className="fa fa-ellipsis-v"
                                  aria-hidden="true"
                                ></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  className="printLabelBtn"
                                  disabled={!item.ShippingLabel || item?.BookingStatus === 'Refunded' || item?.BookingStatus === 'Cancellation In-Progress' || !item.IsPrintLabelEnable}
                                  onClick={() => handlePrintLabel(item)}
                                >
                                  Print Label
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="emailLabelBtn"
                                  onClick={() => handleEmailLabel(item)}
                                  disabled={item?.BookingStatus === 'Refunded' || item?.BookingStatus === 'Cancellation In-Progress' || !item.IsPrintLabelEnable}
                                >
                                  Email Label
                                </Dropdown.Item>
                                {!findIsHostShipAi() && (
                                  <>
                                    <Dropdown.Item
                                      className="emailLabelBtn"
                                      onClick={(e) => handlePackingSlip(e, item)}
                                      disabled={!item.OrderNumber || !item.IsPrintLabelEnable}
                                      id="emailLabelBtn"
                                    >
                                      Packing Slips
                                    </Dropdown.Item>
                                  </>
                                )}
                                <Dropdown.Item
                                  className="emailLabelBtn"
                                  onClick={(e) => handleRequestRefund(e, item)}
                                  id="emailLabelBtn"
                                  disabled={item?.BookingStatus == 'Cancellation In-Progress' || item?.BookingStatus === 'Refunded' || !item.IsPrintLabelEnable}
                                >
                                  Request Refund
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="emailLabelBtn"
                                  onClick={(e) => handleGenerateBarcode(e, item)}
                                  disabled={!item.IsPrintLabelEnable}
                                >
                                  Generate Barcode
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="emailLabelBtn"
                                  onClick={(e) => handleEditReship(e, item)}
                                >
                                  Edit & Reship
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                  {historyRecordStatus === "success" &&
                    historyRecords?.Entity?.historyTrackEntities?.length ===
                    0 && (
                      <tr>
                        <td colSpan={12} align="center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
            </div>
          </div>
          {modalShow && (
            <DraftEmail
              dispatch={dispatch}
              modalShow={modalShow}
              setModalShow={setModalShow}
              selectedRecord={selectedRecord}
            />
          )}
        </div>
        <BatchPagination
          gridData={historyData}
          totalVisualRecords={defaultFilterData.length}
          numberOfPage={defaultFilterData.pageSize}
          numOfPage={numOfPage}
          loader={loader}
          currentPage={defaultFilterData.pageIndex}
          totalPages={totalPages}
          setCurrentPage={(value) => setDefaultFilterData({ ...defaultFilterData, pageIndex: value })}
          totalRecords={historyRecords?.Entity?.TotalRecords}
          setNumberOfPage={(value) => setDefaultFilterData({ ...defaultFilterData, pageSize: value, pageIndex: 1 })}
        />

        {showAlertModal.show &&
          <AlertDialogModal
            modalShow={showAlertModal.show}
            handleCancelDeleteAlert={() => setShowAlertModal({ show: false, record: null })}
            modalClass={'modalDeleteWrapper'}
            messageText={`Are you sure, you want to request refund for ${Array.isArray(showAlertModal.record) ? 'these records' : 'this record'}?`}
            handleYesDeleteAlert={handleDeleteConfirm}
            headingText={'Request Refund'}
          />
        }
        {showTrackingModal &&
          <TrackingDetails
            show={showTrackingModal}
            trackingNumber={currentItemSelected?.TrackingNumber}
            onHide={() => setShowTrackingModal(false)}
            item={currentItemSelected}
          />
        }
        {showUniUniTrackingModal &&
          <UniUniTrackingDetails
            show={showUniUniTrackingModal}
            trackingNumber={currentItemSelected?.TrackingNumber}
            onHide={() => setShowUniUniTrackingModal(false)}
            item={currentItemSelected}
          />
        }
        {showGoFoTrackingModal &&
          <GoFoTrackingDetails
            show={showGoFoTrackingModal}
            trackingNumber={currentItemSelected?.TrackingNumber}
            onHide={() => setShowGoFoTrackingModal(false)}
            item={currentItemSelected}
          />
        }
      </div>
    </main>
  );
}

export default TrackHistory;
